import { t } from "i18next";

import { DeviationUpdateData } from "../../../Deviation/DeviationUpdateData";
import { LocalData } from "../../../General/LocalData";
import { NotificationData } from "../NotificationData";

export class NotificationDeviationActivityData extends NotificationData {
  propertyID: string = "";
  deviationID: string = "";
  updateID: string = "";
  deviationName: string = "";
  authorID: string = "";
  authorName: string = "";
  updateData: DeviationUpdateData | undefined = undefined;

  setup(data: any) {
    this.type = NotificationData.types.DEVIATION_ACTIVITY;

    if (data.notificationData) {
      this.propertyID = data.notificationData.propertyID ?? "";
      this.deviationID = data.notificationData.deviationID ?? "";
      this.updateID = data.notificationData.updateID ?? "";
      this.deviationName = data.notificationData.deviationName ?? "";
      this.authorID = data.notificationData.authorID ?? "";
      this.authorName = data.notificationData.authorName ?? "";

      if (data.notificationData?.updateData) {
        this.updateData = LocalData.properties.addData(this.propertyID).deviations.addData(this.deviationID).updates.addData(this.updateID);
        this.updateData.setup(data.notificationData.updateData);
      }
      this.userForImageView = LocalData.users.addData(this.authorID);

      this.title = data.notificationData?.title ?? this.deviationName + " (" + (LocalData.properties.getData(this.propertyID)?.name ?? "") + ")";
      this.body = `${this.authorName} ${t("main.deviationNotification_hasUpdated")} ${this.deviationName}`;
      this.redirectPath = `/properties/${this.propertyID}/tasks/${this.deviationID}`;
    }
    super.setup(data);
  }
}
